import React from 'react';

function InlineImage({ image, alt_text = '', caption = '' }) {
  if (!image) return null;

  return (
    <figure>
      <img src={image} alt={alt_text} className="lozad auto mb-2" />
      {caption ? (
        <figcaption className="text-left leading-normal">{caption}</figcaption>
      ) : null}
    </figure>
  );
}
export default InlineImage;
